import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, PREFIXES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { each, object } from 'underscore';
import { WidgetLibraryService } from '../../services/widget-library.service';
import { chart } from 'highcharts';
@Component({
	selector: 'app-sem-responsive-search-ads',
	templateUrl: './sem-responsive-search-ads.component.html',
	styleUrls: ['./sem-responsive-search-ads.component.css']
})
export class SemResponsiveSearchAdsComponent implements OnInit {
	@ViewChild('myTable') table: any;

	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() secondarykey: string;
	@Input() tertiarykey: string;
	@Input() downloadconfig: string;
	@Input() datatableconfig;
	@Input() sectionclass: string;
	@Input() sortdataby: string;
	@Input() legend;
	@Input() downloadcsvcolumns: any;
	@Input() colcount: any;
	@Input() nodatamessage: string;
	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;
	@Input() seriesviewconfiguration: any;

	public hasData: boolean;
	public reloadSubscription;
	public widgetDataSubscription;
	public creatives: CreativePerformance[] = [];
	public showLoad = true;
	public formattedData = [];
	public downloadConfiguration: DownloadConfig;
	public currentSortingKey;
	public currentOpenedAd = -1;
	public currentOpenedAdGroup = -1;
	public isR13: boolean = false;
	public isR9: boolean = false;
	public isR8: boolean = false;
	public isR11: boolean = false;
	public isR10: boolean = false;
	public showTooltip: boolean = false;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'small'
	};
	public showLoadForAds = false;
	public showCombinations = false;
	public adExpactionKey: string;
	tableConfig: any;
	columns: any[];
	itemsPerPage: any;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected widgetLibraryService: WidgetLibraryService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.tableConfig = this.datatableconfig;
		this.columns = this.generateColumnConfigurationForDataTable();
		this.isR13 = this.analyticsDataModel.config.version === 'R13' ? true : false;
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isR11 = this.analyticsDataModel.config.version === 'R11' ? true : false;
		this.isR10 = this.analyticsDataModel.config.version === 'R10' ? true : false;
		this.showTooltip = this.isR13 || this.isR11;
		if (this.isR8) this.tooltipOptions['theme'] = 'sem light';
		if (this.isR10) this.currentSortingKey = 'nokey';
		this.itemsPerPage = this.colcount != 'undefined' && this.colcount != 'null' ? this.colcount : 10;
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
		this.sortdataby = this.sortdataby && !(this.sortdataby === undefined) ? this.sortdataby : 'clicks';
		this.adExpactionKey = this.secondarykey ? this.secondarykey : this.tertiarykey;
		this.requestData();
	}
	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.processResponseData(res.data);
				this.analyticsService.checkDateRange();
			} else {
				this.hasData = false;
			}
		});
	}
	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.creatives = this.groupArrayOfObjectsByAdgroup(this.creatives, 'adgroup_id');
			let adgroup_ids = Object.keys(this.creatives);
			this.formattedData = [];
			adgroup_ids.forEach((id, index) => {
				let eachAdgroup: any = {};
				let eachValue = this.creatives[id];
				eachAdgroup.name = eachValue[0]['adgroup_name'];
				eachAdgroup.impressions = eachValue
					.filter((item) => item.ad_type != '')
					.reduce((prev, next) => {
						return prev + next.impressions;
					}, 0);
				eachAdgroup.clicks = eachValue
					.filter((item) => item.ad_type != '')
					.reduce((prev, next) => {
						return prev + next.clicks;
					}, 0);
				eachAdgroup.ctr = ((eachAdgroup.clicks / eachAdgroup.impressions) * 100).toFixed(2);
				eachAdgroup.abs_top_impression_share = eachValue
					.filter((item) => item.ad_type != '')
					.reduce((prev, next) => {
						return prev + (next.abs_top_impression_share * next.impressions) / eachAdgroup.impressions;
					}, 0)
					.toFixed(2);
				eachAdgroup.top_impression_share = eachValue
					.filter((item) => item.ad_type != '')
					.reduce((prev, next) => {
						return prev + (next.top_impression_share * next.impressions) / eachAdgroup.impressions;
					}, 0)
					.toFixed(2);
				let ads = [];
				let combinations = [];
				eachValue.forEach((element) => {
					let eachAd: any = {};
					if (element.ad_type != null && element.ad_type !== 'RESPONSIVE_SEARCH_AD' && element.ad_type !== '') {
						eachAd.name = element.ad_headline == '' ? '[' + element.ad_type + ']' : element.ad_headline;
						eachAd.ad_class = !element.ad_type.toUpperCase().includes('DYNAMIC')
							? 'EXPANDED_TEXT_AD'
							: 'Dynamically_generated_headline';
						eachAd.tooltipHeadlines = element.ad_headline == '' ? '[' + element.ad_type + ']' : element.ad_headline;
						(eachAd.ad_type = !element.ad_type.toUpperCase().includes('DYNAMIC')
							? element.ad_type
							: 'Dynamically_generated_headline'),
							(eachAd.ad_id = element.ad_id);
						eachAd.description = element.description;
						eachAd.impressions = element.impressions;
						eachAd.clicks = element.clicks;
						eachAd.ctr = element.clickthroughrate;
						eachAd.abs_top_impression_share = element.absTopImpressionShare;
						eachAd.top_impression_share = element.topImpressionShare;
						eachAd.top_combinations = [
							{
								name: element.ad_headline == '' ? '[' + element.ad_type + ']' : element.ad_headline,
								ad_type: !element.ad_type.toUpperCase().includes('DYNAMIC')
									? element.ad_type
									: 'Dynamically_generated_headline',
								website:
									(element.ad_type.toUpperCase().includes('DYNAMIC')
										? 'Dynamically_generated_headline'
										: element.ad_type) == 'Dynamically_generated_headline'
										? element.final_url
										: element.final_url
										? element.final_url.substring(
												element.final_url.indexOf('http') > -1
													? element.final_url.indexOf('http')
													: element.final_url.indexOf('www.') > -1
													? element.final_url.indexOf('www.')
													: 0,
												element.final_url.indexOf('"]') > -1
													? element.final_url.indexOf('"]')
													: element.final_url.length
										  )
										: '',
								description: element.description,
								location: element.location,
								siteLinks: element.siteLinks,
								phone: element.callExtension,
								structuredSnippetExtn: element.structuredSnippetExtn,
								calloutsExtn: element.calloutsExtn
							}
						];
						ads.push(eachAd);
					} else {
						if (element.ad_type == 'RESPONSIVE_SEARCH_AD') {
							eachAd.name = element.ad_headline && element.ad_headline != '' ? element.ad_headline : element.ad_type;
							eachAd.ad_type = element.ad_type;
							eachAd.ad_class = element.ad_type;
							eachAd.ad_id = element.ad_id;
							eachAd.description = element.description;
							eachAd.impressions = element.impressions;
							eachAd.clicks = element.clicks;
							eachAd.ctr = element.clickthroughrate;
							eachAd.abs_top_impression_share = element.absTopImpressionShare;
							eachAd.top_impression_share = element.topImpressionShare;
							eachAd.tooltipHeadlines = element.ad_headline;
							eachAd.top_combinations = [];
							ads.push(eachAd);
						}
					}
				});
				eachAdgroup.ads = ads.sort((a, b) => {
					if (a[this.sortdataby] > b[this.sortdataby]) {
						return -1;
					} else if (a[this.sortdataby] < b[this.sortdataby]) {
						return 1;
					} else {
						if (a['impressions'] > b['impressions']) {
							return -1;
						} else {
							return 1;
						}
					}
				});
				this.formattedData.push(eachAdgroup);
			});
			this.formattedData = this.formattedData.sort((a, b) => {
				if (a[this.sortdataby] > b[this.sortdataby]) {
					return -1;
				} else if (a[this.sortdataby] < b[this.sortdataby]) {
					return 1;
				} else {
					if (a['impressions'] > b['impressions']) {
						return -1;
					} else {
						return 1;
					}
				}
			});
		} else {
			this.hasData = false;
		}
	}

	groupArrayOfObjectsByAdgroup(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	protected mapResponseDataToInterface(responseData) {
		const creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: any = {};
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			const locationObj =
				!UtilityService.isUndefinedOrNull(response.location_extn_attribute_values) &&
				response.location_extn_attribute_values != ''
					? JSON.parse(response.location_extn_attribute_values.replaceAll('\\"', '"'))[0]
					: {};
			creativeObj.ad_headline = UtilityService.isUndefinedOrNull(response.ad_headline)
				? ''
				: response.ad_headline == ''
				? ' '
				: response.ad_headline;
			creativeObj.ad_title = UtilityService.isUndefinedOrNull(response.ad_title)
				? ''
				: response.ad_title == ''
				? ''
				: response.ad_title;
			creativeObj.clicks = parseFloat(response.clicks);
			creativeObj.clickthroughrate = response.clickthroughrate
				? parseFloat(response.clickthroughrate)
				: response.clicks && response.impressions
				? (response.clicks / response.impressions) * 100
				: '';
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.individualImpressions = response.individual_impressions
				? parseFloat(response.individual_impressions)
				: null;
			creativeObj.avg_position = parseFloat(response.avg_position);
			creativeObj.adgroup_name = UtilityService.isUndefinedOrNull(response.adgroup_name) ? '' : response.adgroup_name;
			creativeObj.adgroup_id = UtilityService.isUndefinedOrNull(response.adgroup_id) ? '' : response.adgroup_id;
			creativeObj.ad_id = UtilityService.isUndefinedOrNull(response.ad_id) ? '' : response.ad_id;
			creativeObj.ad_type = UtilityService.isUndefinedOrNull(response.ad_type) ? '' : response.ad_type;
			creativeObj.ad_description = UtilityService.isUndefinedOrNull(response.ad_description)
				? ''
				: response.ad_description;
			if (this.customchartconfiguration) {
				creativeObj.chartData = {
					days: response.creatives_by_date ? response.creatives_by_date : [],
					weeks: response.creatives_by_week ? response.creatives_by_week : [],
					months: response.creatives_by_month ? response.creatives_by_month : []
				};
			}
			creativeObj.top_impression_share = parseFloat(response.top_impression_share);
			creativeObj.abs_top_impression_share = parseFloat(response.abs_top_impression_share);
			creativeObj.topImpressionShare = parseFloat(response.top_impression_share).toFixed(2);
			creativeObj.absTopImpressionShare = parseFloat(response.abs_top_impression_share).toFixed(2);
			creativeObj.callExtension =
				response && response.call_extn_attribute_values
					? JSON.parse(response.call_extn_attribute_values.replaceAll('\\"', '"'))[0][1]
					: '';

			const siteLinks =
				!UtilityService.isUndefinedOrNull(response.sitelink_extn_attribute_values) &&
				response.sitelink_extn_attribute_values !== ''
					? JSON.parse(response.sitelink_extn_attribute_values.replaceAll(' "', ' ').replaceAll('" ', ' '))
					: [];
			let locationArr = [];
			for (let prop in locationObj) {
				if (parseInt(prop) > 1 && parseInt(prop) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			location = locationArr.join(', ');
			creativeObj.location = location;
			if (response.structuredsnippet_extn_attribute_values) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn_attribute_values);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn_attribute_values) {
				calloutsExtn = JSON.parse(response.callouts_extn_attribute_values);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}
			for (const item of siteLinks) {
				siteLinksArr.push({
					heading: item['1'] || '',
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					link: item['5'][0] || ''
				});
			}
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.siteLinks = siteLinksArr;
			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativeObj.responsiveAdTitle = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];
			creativeObj.responsiveAdDescription = !UtilityService.isUndefinedOrNull(response.responsive_ad_title)
				? JSON.parse(response.responsive_ad_title)
				: [];
			creativeObj.description = [];
			if (creativeObj.ad_type == 'RESPONSIVE_SEARCH_AD') {
				creativeObj.ad_headline =
					creativeObj.responsiveAdTitle.length > 1
						? creativeObj.responsiveAdTitle[0]['text'] +
						  ' + ' +
						  (creativeObj.responsiveAdTitle.length - 1) +
						  ' more headlines'
						: creativeObj.responsiveAdTitle.length == 1
						? creativeObj.responsiveAdTitle[0]['text']
						: '';
				creativeObj.responsiveAdDescription.forEach((item) => creativeObj.description.push(item['text']));
				creativeObj.final_url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
			} else if (creativeObj.ad_type.toUpperCase().includes('DYNAMIC')) {
				creativeObj.ad_headline = 'Dynamically generated headline';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				if (descpt1 !== '') {
					creativeObj.description.push(descpt1);
				}
				if (descpt2 !== '') {
					creativeObj.description.push(descpt2);
				}
				creativeObj.final_url = 'Dynamically generated display URL';
			} else if (creativeObj.ad_type.toUpperCase().includes('CALL_ONLY_AD')) {
				creativeObj.ad_headline = response.scaa_headline
					? response.scaa_headline.substring(0, 30)
					: response.headline
					? response.headline.substring(0, 30)
					: '';
				let descpt1 = response.scaa_description1
					? response.scaa_description1.substring(0, 90)
					: response.description1
					? response.description1.substring(0, 90)
					: '';
				let descpt2 = response.scaa_description2
					? response.scaa_description2.substring(0, 90)
					: response.description2
					? response.description2.substring(0, 90)
					: '';
				if (descpt1 !== '') {
					creativeObj.description.push(descpt1);
				}
				if (descpt2 !== '') {
					creativeObj.description.push(descpt2);
				}
				creativeObj.final_url = UtilityService.isUndefinedOrNull(response.scaa_display_url)
					? UtilityService.isUndefinedOrNull(response.display_url)
						? ''
						: response.display_url
					: response.scaa_display_url;
			} else {
				let ad_headlines = [];
				ad_headlines.push(
					response.scaa_headline_part1
						? response.scaa_headline_part1.substring(0, 30)
						: response.headline_part1
						? response.headline_part1.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part2
						? response.scaa_headline_part2.substring(0, 30)
						: response.headline_part2
						? response.headline_part2.substring(0, 30)
						: ''
				);
				ad_headlines.push(
					response.scaa_headline_part3
						? response.scaa_headline_part3.substring(0, 30)
						: response.headline_part3
						? response.headline_part3.substring(0, 30)
						: ''
				);
				creativeObj.ad_headline = ad_headlines.join(' | ');
				creativeObj.description.push(
					response.scaa_description
						? response.scaa_description.substring(0, 90)
						: response.description
						? response.description.substring(0, 90)
						: ''
				);
				creativeObj.final_url = UtilityService.isUndefinedOrNull(response.scaa_creative_final_urls)
					? UtilityService.isUndefinedOrNull(response.creative_final_urls)
						? ''
						: response.creative_final_urls
					: response.scaa_creative_final_urls;
			}
			creativePerformances.push(creativeObj);
		}
		return creativePerformances;
	}

	generateColumnConfigurationForDataTable(): any[] {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		const columnsConfig = UtilityService.checkForVisibilityPermissions(this.tableConfig.columns, dateSet);
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = {} as any;
			colObj.name = colConfig.columnName;
			colObj.shortName = colConfig.columnNameShort;
			colObj.prop = colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			colObj.suffix = colConfig.columnSuffix;
			colObj.type = colConfig.columnType;
			colObj.flexGrow = colConfig.columnFlexGrow ?? 1;
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			columns.push(colObj);
		}
		return columns;
	}

	getAdData(ad, chartConfig, key, index, value, flag): void {
		const fetchGraphData = chartConfig && chartConfig !== '' ? true : false;
		if (
			(ad.ad_type == 'RESPONSIVE_SEARCH_AD' && ad.top_combinations.length == 0) ||
			(ad.ad_type !== 'RESPONSIVE_SEARCH_AD' && !ad.chartData)
		) {
			this.showLoad = true;

			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.adExpactionKey, ad.ad_id, ad.ad_type, fetchGraphData, null)
				.subscribe((res: any) => {
					if (res.data) {
						ad['chartData'] = {
							days: res.data.creatives_by_date ? res.data.creatives_by_date : [],
							weeks: res.data.creatives_by_week ? res.data.creatives_by_week : [],
							months: res.data.creatives_by_month ? res.data.creatives_by_month : []
						};
						let combinations = [];
						delete res.data['creatives_by_date'];
						delete res.data['creatives_by_week'];
						delete res.data['creatives_by_month'];

						if (ad.ad_type == 'RESPONSIVE_SEARCH_AD') {
							for (let key in res.data) {
								combinations.push(res.data[key]);
							}
							combinations = combinations.sort((a, b) => {
								return parseInt(a['impressions']) > parseInt(b['impressions']) ? -1 : 1;
							});
							combinations.forEach((adHeadline) => {
								let eachOne: any = {};
								adHeadline.ad_title = adHeadline.ad_title
									? adHeadline.ad_title.replaceAll(`""`, `"`).replaceAll(`"[`, `[`).replaceAll(`]"`, `]`)
									: '';
								eachOne.name =
									adHeadline.ad_title != '' && adHeadline.ad_title != '[]'
										? JSON.parse(
												adHeadline.ad_title.substring(
													adHeadline.ad_title.indexOf('[') - 1,
													adHeadline.ad_title.indexOf(']') + 1
												)
										  )
												.map((item) => item.text)
												.reduce((prev, next) => {
													return prev != '' ? prev + ' | ' + next : next;
												}, '')
										: '[' + ad.ad_type + ']';
								eachOne.website =
									adHeadline.creative_final_urls && adHeadline.creative_final_urls != ''
										? adHeadline.creative_final_urls.substring(
												adHeadline.creative_final_urls.indexOf('http') > -1
													? adHeadline.creative_final_urls.indexOf('http')
													: adHeadline.creative_final_urls.indexOf('www.') > -1
													? adHeadline.creative_final_urls.indexOf('www.')
													: 0,
												adHeadline.creative_final_urls.indexOf('"]') > -1
													? adHeadline.creative_final_urls.indexOf('"]')
													: adHeadline.creative_final_urls.length
										  )
										: '';
								eachOne.ad_type = ad.ad_type;
								adHeadline.ad_description = adHeadline.ad_description
									? adHeadline.ad_description.replaceAll(`""`, `"`).replaceAll(`"[`, `[`).replaceAll(`]"`, `]`)
									: '';
								eachOne.description =
									adHeadline.ad_description != '' && adHeadline.ad_description != '[]'
										? JSON.parse(adHeadline.ad_description)
												.map((item) => item.text)
												.reduce((prev, next) => {
													return prev != '' ? prev + ' | ' + next : next;
												}, '')
										: '';
								eachOne.impressions = adHeadline.impressions;
								eachOne.percentage = ((adHeadline.impressions / ad.impressions) * 100).toFixed(2);
								ad.top_combinations.push(eachOne);
							});
						}
						this.expand(key, index, value, flag);
						this.showLoad = false;
					} else {
						this.showLoad = false;
					}
				});
		} else {
			this.expand(key, index, value, flag);
		}
	}

	expand(key, index, value, flag): void {
		switch (key) {
			case 'adgroup':
				if (flag) {
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details`
					).removeClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .adgroup-values .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .adgroup-values .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .openIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .closeIcon`
					).css({ display: 'initial' });
					this.formattedData = [...this.formattedData];
				} else {
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details`
					).removeClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .closeIcon`
					).css({ display: 'none' });
					this.formattedData = [...this.formattedData];
				}
				break;
			case 'ads':
				if (flag) {
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .combinations`
					).addClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('show-content');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .openIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .closeIcon`
					).css({ display: 'initial' });
					this.formattedData = [...this.formattedData];
				} else {
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('expand');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).removeClass('show-content');
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .closeIcon`
					).css({ display: 'none' });
					this.formattedData = [...this.formattedData];
				}
				break;
			default:
				break;
		}
	}

	scrollGraph(adsList, i): void {
		if (i < 0) {
			i = adsList.length - 1;
		} else if (i >= adsList.length) {
			i = 0;
		}
		jQuery('.ads-details').animate(
			{
				scrollTop: jQuery('.ads-details').scrollTop() + jQuery('#ad_' + i).position().top
			},
			100
		);
	}

	sortDataBasedOnKey(key, type, index): void {
		this.sortdataby = key;
		if (type !== 'string') {
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('active');
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('ascending');
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('descending');
			jQuery(
				`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
					index + 1
				})`
			).addClass('active');
			if (this.currentSortingKey && this.currentSortingKey != key) {
				this.formattedData.sort((a, b) => {
					return a[key] - b[key];
				});
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			} else if (this.currentSortingKey == key) {
				this.formattedData.sort((a, b) => {
					return b[key] - a[key];
				});
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('descending');
				this.currentSortingKey = null;
			} else {
				this.formattedData.sort((a, b) => {
					return a[key] - b[key];
				});
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			}
		} else {
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('active');
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('ascending');
			jQuery(
				'.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name'
			).removeClass('descending');
			jQuery(
				`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
					index + 1
				})`
			).addClass('active');
			if (this.currentSortingKey && this.currentSortingKey != key) {
				this.formattedData.sort((a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0));
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			} else if (this.currentSortingKey == key) {
				this.formattedData.sort((a, b) => (a[key] < b[key] ? -1 : b[key] < a[key] ? 1 : 0));
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('descending');
				this.currentSortingKey = null;
			} else {
				this.formattedData.sort((a, b) => (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0));
				jQuery(
					`.sem-RSA:not(.sem-ad-assets) .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			}
		}
	}

	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			null,
			null,
			this.downloadConfiguration.newTabCsvQueryKey,
			this.downloadConfiguration.newTabCsvFileName
		);
	}
}
